import React, { Fragment } from "react";
import classNames from "classnames";
import { Field } from "formik";
import TextEditor from "app/react/components/inputs/TextEditor";
import DisableSection from "./components/DisableSection";
import FormField from "../../../formfields/FormField";
import DatePickerField from "../../../datePicker/DatePickerField";
import Checkbox from "../../../checkbox/Checkbox";

const GuestListSection = ({ setFieldValue, sectionId, values }) => {
  return (
    <div className="artist-dialog__section">
      <div className="artist-dialog__section-inner">
        <h3>Guest list</h3>
        <span
          className={classNames([
            "artist-dialog__configure-setup-button",
            "artist-dialog__configure-setup-button--active",
          ])}
        >
          Configure your setup
        </span>
        <div className="artist-dialog__section-inner__content">
          <DisableSection sectionId={sectionId} values={values} />
          <Field
            name={`${sectionId}.name`}
            label="Rename"
            as={FormField}
            disabled={!values.enabled}
          />
          <label>
            Deadline
            <DatePickerField
              value={values.deadline}
              name={`${sectionId}.deadline`}
              onChange={setFieldValue}
              showPopperArrow={false}
              isLeft
              disabled={!values.enabled}
            />
          </label>
          {values.enabled && (
            <Field name={`${sectionId}.description`} label="Intro text">
              {({ field }) => {
                return (
                  <Fragment>
                    <span className={"form-field__label"}>Intro text</span>
                    <TextEditor
                      imageInsertButtonsOverride={[
                        "imageBack",
                        "|",
                        "imageByURL",
                      ]}
                      height={200}
                      onBlur={(e) =>
                        setFieldValue(
                          `${sectionId}.description`,
                          e.target.value
                        )
                      }
                      id={"introText"}
                      value={field.value}
                    />
                  </Fragment>
                );
              }}
            </Field>
          )}
          {!values.enabled && (
            <Field name={`${sectionId}.description`} label="Intro text">
              {({ field }) => {
                return (
                  <Fragment>
                    <span className={"form-field__label"}>Intro text</span>
                    <div style={{ position: "relative", height: 295 }}>
                      <div className="artist-dialog__text-editor--disabled"></div>
                      <TextEditor
                        imageInsertButtonsOverride={[
                          "imageBack",
                          "|",
                          "imageByURL",
                        ]}
                        height={200}
                        id={"introText"}
                        value={field.value}
                      />
                    </div>
                  </Fragment>
                );
              }}
            </Field>
          )}
          <h5 className="artist-dialog__subheader">LIMITS</h5>
          <label>
            <span className={"form-field__label"}>Overall guest limit</span>
            <Field name={`${sectionId}.limit`} type="number" disabled={!values.enabled} />
          </label>
          <label>
            <span className={"form-field__label"}>Max. artist guest list</span>
            <Field name={`${sectionId}.limit_for_2`} type="number" disabled={!values.enabled} />
          </label>
          <label>
            <span className={"form-field__label"}>Max. VIP</span>
            <Field name={`${sectionId}.limit_for_3`} type="number" disabled={!values.enabled} />
          </label>
          <Field
            name={`${sectionId}.update_bookings`}
            id={`${sectionId}-update_bookings`}
            as={Checkbox}
            label="Update limits for existing bookings"
			disabled={!values.enabled}
          />
          <h5 className="artist-dialog__subheader">OPTIONAL FIELDS</h5>
          <Field
            name={`${sectionId}.require_email_address`}
            id={`${sectionId}-require_email_address`}
            as={Checkbox}
            label="Require to provide an email address for guests"
			disabled={!values.enabled}
          />
          <Field
            name={`${sectionId}.enable_birthday`}
            id={`${sectionId}-enable_birthday`}
            as={Checkbox}
            label="Enable to provide the guests birthday"
			disabled={!values.enabled}
          />
          <Field
            name={`${sectionId}.require_birthday`}
            id={`${sectionId}-require_birthday`}
            as={Checkbox}
            label="Require to provide the guests birthday"
            disabled={!values.enable_birthday || !values.enabled}
          />
        </div>
      </div>
    </div>
  );
};

GuestListSection.propTypes = {};

export default GuestListSection;
